<script setup lang="ts">
// A document-scan glyph: four corner brackets framing a scan line. The design
// uses it on "Reading…" pills — PrimeIcons has no scan / viewfinder icon, and a
// spinner or sparkle reads as generic loading rather than "reading the page".
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path d="M2 5V3.5A1.5 1.5 0 0 1 3.5 2H5" />
    <path d="M11 2h1.5A1.5 1.5 0 0 1 14 3.5V5" />
    <path d="M14 11v1.5a1.5 1.5 0 0 1-1.5 1.5H11" />
    <path d="M5 14H3.5A1.5 1.5 0 0 1 2 12.5V11" />
    <path d="M4.5 8h7" />
  </svg>
</template>
